// usePlaces.js
import {ref} from 'vue';
import api from "@/api/api";

const placeSizes = ref([]);
const placeSizesLoading = ref(false);
const placeSizesLoaded = ref (false);

const fetchPlaceSizes = async () => {
    if(placeSizesLoaded.value) {
        return;
    }
    placeSizesLoading.value = true;
    try {
        const response = await api.get('/place_sizes/');
        placeSizes.value = response.data;
        placeSizesLoaded.value = true;
    } catch (error) {
        console.error('Error fetching places:', error);
    } finally {
        placeSizesLoading.value = false;
    }
};

const getPlaceSizeById = (id) => {
    const placeSize = placeSizes.value.find(placeSize => placeSize.id === id);
    return placeSize;
};

export default function usePlaceSizes() {
    if (placeSizes.value.length === 0 && !placeSizesLoading.value) {
        fetchPlaceSizes();
    }
    return { placeSizes, placeSizesLoading, fetchPlaceSizes, placeSizesLoaded, getPlaceSizeById };
}
